<template>
  <div class="my-4">
    <Disclosure
      as="div"
      v-for="(dataList, index) in dataLists"
      :key="index"
      class="border-b border-blue-chill md:pr-4"
      v-slot="{ open }"
    >
      <CommonAccordianDetail
        :data="dataList"
        :isList="isList"
        :isClinicDetail="isClinicDetail"
        :open="open"
      ></CommonAccordianDetail>
    </Disclosure>
  </div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";

defineProps({
  dataLists: Array,
  isList: {
    type: Boolean,
    default: false,
  },
  isClinicDetail: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(false);
let checkedValue = ref([]);

function onShow() {
  isOpen.value = !isOpen.value;
}
function accept() {
  isOpen.value = false;
}

function onOptionClicked(val) {
  checkedValue.value.push(val);
}
</script>
